import { z } from 'zod';

import { FileDto } from '../../table/cell-renderer/FileDownloadCellRenderer';

const WorkflowStepTooltipComment = z.object({ value: z.string() });
const WorkflowStepModalComment = z.object({
  type: z.literal('modal'),
  modalId: z.string(),
  tooltip: z.string(),
});
const WorkflowStepComment = z.union([
  WorkflowStepTooltipComment,
  WorkflowStepModalComment,
]);

const WorkflowStep = z.object({
  title: z.string(),
  files: z.array(FileDto).optional(),
  comments: z.array(WorkflowStepComment).optional(),
  triggeredAt: z.string().nullable().optional(),
  triggeredBy: z.string().nullable().optional(),
  isTriggered: z.boolean(),
});

const WorkflowVisualizationData = z.object({
  steps: z.array(WorkflowStep),
});

export type WorkflowStepFile = z.infer<typeof FileDto>;

export function isWorkflowStepFile(data: unknown): data is WorkflowStepFile {
  return FileDto.safeParse(data).success;
}

export type WorkflowStep = z.infer<typeof WorkflowStep>;
export type WorkflowVisualizationData = z.infer<
  typeof WorkflowVisualizationData
>;
export type WorkflowStepComment = z.infer<typeof WorkflowStepComment>;
export type WorkflowStepModalComment = z.infer<typeof WorkflowStepModalComment>;
export type WorkflowStepTooltipComment = z.infer<
  typeof WorkflowStepTooltipComment
>;

export function isWorkflowVisualizationData(
  data: unknown
): data is WorkflowVisualizationData {
  return WorkflowVisualizationData.safeParse(data).success;
}
